import React, {useState} from "react";
export default (props) => {
	const [input1, onChangeInput1] = useState('');
	return (
		<div 
			style={{
				display: "flex",
				flexDirection: "column",
				background: "#FFFFFF",
			}}>
			<div 
				style={{
					height: 2890,
					alignSelf: "stretch",
					background: "#F6F7F9",
				}}>
				<div 
					style={{
						alignSelf: "stretch",
						display: "flex",
						flexDirection: "column",
						alignItems: "flex-start",
						paddingBottom: 89,
					}}>
					<div 
						style={{
							display: "flex",
							flexDirection: "column",
							alignItems: "center",
							position: "relative",
						}}>
						{/* <div 
							style={{
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
								background: "#FFFFFF",
								paddingTop: 32,
								paddingBottom: 310,
							}}>
							<img
								src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/6tj2evlg_expires_30_days.png"} 
								style={{
									width: 80,
									height: 80,
									marginBottom: 16,
									marginLeft: 32,
									objectFit: "fill",
								}}
							/>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 14,
									marginLeft: 32,
									marginRight: 32,
									gap: 12,
								}}>
								<span 
									style={{
										color: "#2C2C2C",
										fontSize: 18,
										fontWeight: "bold",
									}} >
									{"Guy Hawkins"}
								</span>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
										borderRadius: 3,
										paddingTop: 1,
										paddingBottom: 1,
										paddingLeft: 6,
										paddingRight: 6,
									}}>
									<span 
										style={{
											color: "#FFFFFF",
											fontSize: 10,
											fontWeight: "bold",
										}} >
										{"Mentee"}
									</span>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									paddingRight: 2,
									marginBottom: 64,
									marginLeft: 32,
									marginRight: 32,
									gap: 6,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/4ws255pl_expires_30_days.png"} 
									style={{
										width: 15,
										height: 15,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 12,
									}} >
									{"yourguy123@email.com"}
								</span>
							</div>
							<span 
								style={{
									color: "#979797",
									fontSize: 12,
									fontWeight: "bold",
									marginBottom: 32,
									marginLeft: 32,
								}} >
								{"MAIN MENU"}
							</span>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/v0y5c1pj_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Dashboard"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 4,
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/5x4pfz3j_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Requests"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/o0nz0rzj_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"My Goals"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/6clm8bv5_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Chats"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/u0nhp1sz_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Curriculum"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/q1p1qx6e_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Lessons"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 32,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/il87bvwd_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Resources"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingTop: 8,
									paddingBottom: 8,
									paddingLeft: 8,
									paddingRight: 11,
									marginBottom: 32,
									marginLeft: 24,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/sz68aii5_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Mentors"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/fq8gsfk2_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Progress"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/44a82st8_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Community"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/ih8xjr1h_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Bookmarks"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/ydo5wjqj_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Downloads"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 40,
									marginLeft: 32,
									marginRight: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/cntw9uzm_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Notifications"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/mrakjaws_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Settings"}
								</span>
							</div>
						</div> */}
						<div 
							style={{
								position: "absolute",
								top: 211,
								left: 0,
								width: 236,
								height: 1,
								background: "#E6E6E6",
							}}>
						</div>
						<div 
							style={{
								position: "absolute",
								bottom: 0,
								left: 227,
								width: 1213,
								display: "flex",
								alignItems: "flex-start",
								background: "#FFFFFF",
								paddingTop: 20,
								paddingBottom: 20,
								paddingLeft: 40,
								paddingRight: 40,
								boxShadow: "0px -2px 4px #00000000",
							}}>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
									flex: 1,
								}} >
								{"© 2025 Global Impact Innovators. All Rights Reserved."}
							</span>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
									marginRight: 27,
								}} >
								{"Privacy"}
							</span>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
									marginRight: 26,
								}} >
								{"Terms of Service"}
							</span>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
								}} >
								{"Help & FAQ"}
							</span>
						</div>
					</div>
					<div 
						style={{
							display: "flex",
							alignItems: "center",
							background: "#FFFFFF",
							paddingTop: 20,
							paddingBottom: 20,
							paddingLeft: 33,
							paddingRight: 33,
							marginBottom: 32,
							marginLeft: 234,
						}}>
						<div 
							style={{
								flexShrink: 0,
								display: "flex",
								alignItems: "center",
								background: "#F6F7F9",
								borderRadius: 8,
								paddingTop: 14,
								paddingBottom: 14,
								paddingLeft: 20,
								paddingRight: 20,
								marginRight: 257,
								gap: 12,
							}}>
							<img
								src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/q173kqdf_expires_30_days.png"} 
								style={{
									width: 21,
									height: 21,
									objectFit: "fill",
								}}
							/>
							<input
								placeholder={"For quick access to courses, mentors, or posts"}
								value={input1}
								onChange={(event)=>onChangeInput1(event.target.value)}
								style={{
									color: "#6C6C6C",
									fontSize: 14,
									width: 306,
									background: "none",
									border: "none",
									paddingTop: 2,
									paddingBottom: 2,
								}}
							/>
						</div>
						<div 
							style={{
								flexShrink: 0,
								display: "flex",
								alignItems: "center",
								background: "#FEF0E9",
								borderRadius: 8,
								paddingTop: 10,
								paddingBottom: 10,
								paddingLeft: 20,
								paddingRight: 23,
								marginRight: 32,
								gap: 8,
							}}>
							<img
								src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/4qikwnkw_expires_30_days.png"} 
								style={{
									width: 32,
									height: 32,
									objectFit: "fill",
								}}
							/>
							<span 
								style={{
									color: "#F57E47",
									fontSize: 17,
									fontWeight: "bold",
								}} >
								{"Ask Giia"}
							</span>
						</div>
						<div 
							style={{
								width: 1,
								height: 58,
								background: "#E6E6E6",
								marginRight: 31,
							}}>
						</div>
						<img
							src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/hz132ztl_expires_30_days.png"} 
							style={{
								width: 24,
								height: 24,
								marginRight: 24,
								objectFit: "fill",
							}}
						/>
						<img
							src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/ly3z0plj_expires_30_days.png"} 
							style={{
								width: 24,
								height: 24,
								objectFit: "fill",
							}}
						/>
					</div>
					<span 
						style={{
							color: "#010101",
							fontSize: 40,
							fontWeight: "bold",
							marginBottom: 32,
							marginLeft: 267,
						}} >
						{"Change Password"}
					</span>
					<div 
						style={{
							display: "flex",
							alignItems: "flex-start",
							background: "#FFFFFF",
							borderRadius: 12,
							paddingLeft: 20,
							paddingRight: 20,
							marginLeft: 267,
							boxShadow: "0px 1px 3px #00000003",
						}}>
						<div 
							style={{
								flexShrink: 0,
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
								marginTop: 20,
								marginRight: 22,
							}}>
							<span 
								style={{
									color: "#979797",
									fontSize: 16,
									fontWeight: "bold",
									marginBottom: 15,
								}} >
								{"Settings"}
							</span>
							<div 
								style={{
									width: 362,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 16,
								}}>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									background: "linear-gradient(180deg, #E7F1F8, #FFFFFF)",
									borderRadius: 12,
									padding: 20,
									marginBottom: 32,
									marginLeft: 2,
									marginRight: 2,
									gap: 16,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/bazuq1od_expires_30_days.png"} 
									style={{
										width: 58,
										height: 58,
										objectFit: "fill",
									}}
								/>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										gap: 7,
									}}>
									<div 
										style={{
											display: "flex",
											alignItems: "center",
											gap: 14,
										}}>
										<span 
											style={{
												color: "#010101",
												fontSize: 18,
												fontWeight: "bold",
											}} >
											{"Guy Hawkins"}
										</span>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
												borderRadius: 3,
												paddingTop: 1,
												paddingBottom: 1,
												paddingLeft: 6,
												paddingRight: 6,
											}}>
											<span 
												style={{
													color: "#FFFFFF",
													fontSize: 10,
													fontWeight: "bold",
												}} >
												{"Mentee"}
											</span>
										</div>
									</div>
									<div 
										style={{
											display: "flex",
											alignItems: "flex-start",
											paddingRight: 2,
											gap: 6,
										}}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/fi8kb0xm_expires_30_days.png"} 
											style={{
												width: 15,
												height: 15,
												objectFit: "fill",
											}}
										/>
										<span 
											style={{
												color: "#6C6C6C",
												fontSize: 12,
												fontWeight: "bold",
											}} >
											{"yourguy123@email.com"}
										</span>
									</div>
								</div>
							</div>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
									fontWeight: "bold",
									marginBottom: 24,
									marginLeft: 2,
								}} >
								{"General Settings"}
							</span>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 28,
									marginLeft: 2,
									marginRight: 2,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/qwkfhs19_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										marginRight: 12,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#2C2C2C",
										fontSize: 16,
										marginRight: 225,
									}} >
									{"Edit Profile"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/ypcg37tp_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 28,
									marginLeft: 2,
									marginRight: 2,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/nsy6a627_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										marginRight: 12,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#1074BC",
										fontSize: 16,
										fontWeight: "bold",
										marginRight: 167,
									}} >
									{"Change Password"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/6ez1ork0_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 62,
									marginLeft: 2,
									marginRight: 2,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/rtcxo9se_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										marginRight: 12,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#2C2C2C",
										fontSize: 16,
										marginRight: 165,
									}} >
									{"Language Settings"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/9mei8v98_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
							</div>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
									fontWeight: "bold",
									marginBottom: 24,
									marginLeft: 2,
								}} >
								{"Account & Security"}
							</span>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 28,
									marginLeft: 2,
									marginRight: 2,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/2ji0hjaq_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										marginRight: 12,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#2C2C2C",
										fontSize: 16,
										marginRight: 176,
									}} >
									{"Account Settings"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/p8d7q2pq_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 62,
									marginLeft: 2,
									marginRight: 2,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/dv419iq2_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										marginRight: 12,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#2C2C2C",
										fontSize: 16,
										marginRight: 34,
									}} >
									{"Manage Data & Sharing Permissions"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/e43805mb_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
							</div>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
									fontWeight: "bold",
									marginBottom: 24,
									marginLeft: 2,
								}} >
								{"Notifications & Support"}
							</span>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 28,
									marginLeft: 2,
									marginRight: 2,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/9o0dln2e_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										marginRight: 12,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#2C2C2C",
										fontSize: 16,
										marginRight: 153,
									}} >
									{"Notification Settings"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/5cpt5fru_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 28,
									marginLeft: 2,
									marginRight: 2,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/hcccufpn_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										marginRight: 12,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#2C2C2C",
										fontSize: 16,
										marginRight: 192,
									}} >
									{"Help & Support"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/4t8wt7kp_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 28,
									marginLeft: 2,
									marginRight: 2,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/o6nbqna6_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										marginRight: 12,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#2C2C2C",
										fontSize: 16,
										marginRight: 276,
									}} >
									{"FAQ"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/i4e8peas_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 62,
									marginLeft: 2,
									marginRight: 2,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/7j09suru_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										marginRight: 12,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#2C2C2C",
										fontSize: 16,
										marginRight: 221,
									}} >
									{"Contact Us"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/mrt25ta7_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
							</div>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
									fontWeight: "bold",
									marginBottom: 24,
									marginLeft: 2,
								}} >
								{"Legal & Policies"}
							</span>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 28,
									marginLeft: 2,
									marginRight: 2,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/72ww6o96_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										marginRight: 12,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#2C2C2C",
										fontSize: 16,
										marginRight: 179,
									}} >
									{"Terms of Service"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/9650absh_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 28,
									marginLeft: 2,
									marginRight: 2,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/70f9qrfb_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										marginRight: 12,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#2C2C2C",
										fontSize: 16,
										marginRight: 201,
									}} >
									{"Privacy Policy"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/fto9opds_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginLeft: 2,
									marginRight: 2,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/vzaxaimk_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										marginRight: 12,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#2C2C2C",
										fontSize: 16,
										marginRight: 236,
									}} >
									{"About Us"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/ttga5h4r_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
							</div>
						</div>
						<div 
							style={{
								width: 1,
								height: 1146,
								background: "#E6E6E6",
								marginRight: 23,
							}}>
						</div>
						<div 
							style={{
								flexShrink: 0,
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
								marginTop: 20,
							}}>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 15,
								}}>
								<span 
									style={{
										color: "#979797",
										fontSize: 16,
										fontWeight: "bold",
										marginRight: 517,
									}} >
									{"Change Password"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/fhg1mxfs_expires_30_days.png"} 
									style={{
										width: 10,
										height: 10,
										objectFit: "fill",
									}}
								/>
							</div>
							<div 
								style={{
									width: 679,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 16,
								}}>
							</div>
							<span 
								style={{
									color: "#2C2C2C",
									fontSize: 12,
									fontWeight: "bold",
									marginBottom: 12,
								}} >
								{"Current Password"}
							</span>
							<button 
								style={{
									display: "flex",
									alignItems: "flex-start",
									background: "#FFFFFF",
									borderRadius: 8,
									border: `1px solid #E6E6E6`,
									paddingTop: 16,
									paddingBottom: 16,
									paddingLeft: 20,
									paddingRight: 20,
									marginBottom: 16,
									textAlign: "left",
								}}
								onClick={()=>alert("Pressed!")}>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 14,
										marginRight: 491,
									}} >
									{"Enter your password"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/v2eo5l2z_expires_30_days.png"} 
									style={{
										width: 17,
										height: 17,
										objectFit: "fill",
									}}
								/>
							</button>
							<span 
								style={{
									color: "#2C2C2C",
									fontSize: 12,
									fontWeight: "bold",
									marginBottom: 12,
								}} >
								{"New Password"}
							</span>
							<button 
								style={{
									display: "flex",
									alignItems: "flex-start",
									background: "#FFFFFF",
									borderRadius: 8,
									border: `1px solid #E6E6E6`,
									paddingTop: 16,
									paddingBottom: 16,
									paddingLeft: 20,
									paddingRight: 20,
									marginBottom: 16,
									textAlign: "left",
								}}
								onClick={()=>alert("Pressed!")}>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 14,
										marginRight: 491,
									}} >
									{"Enter your password"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/cfgv8cib_expires_30_days.png"} 
									style={{
										width: 17,
										height: 17,
										objectFit: "fill",
									}}
								/>
							</button>
							<span 
								style={{
									color: "#2C2C2C",
									fontSize: 12,
									fontWeight: "bold",
									marginBottom: 12,
								}} >
								{"Current Passowrd"}
							</span>
							<button 
								style={{
									display: "flex",
									alignItems: "flex-start",
									background: "#FFFFFF",
									borderRadius: 8,
									border: `1px solid #E6E6E6`,
									paddingTop: 16,
									paddingBottom: 16,
									paddingLeft: 20,
									paddingRight: 20,
									marginBottom: 28,
									textAlign: "left",
								}}
								onClick={()=>alert("Pressed!")}>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 14,
										marginRight: 491,
									}} >
									{"Enter your password"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/byz4ion6_expires_30_days.png"} 
									style={{
										width: 17,
										height: 17,
										objectFit: "fill",
									}}
								/>
							</button>
							<button 
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
									background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
									borderRadius: 8,
									border: "none",
									paddingTop: 16,
									paddingBottom: 16,
									paddingLeft: 247,
									paddingRight: 247,
									textAlign: "left",
								}}
								onClick={()=>alert("Pressed!")}>
								<span 
									style={{
										color: "#FFFFFF",
										fontSize: 14,
										fontWeight: "bold",
									}} >
									{"Update Password"}
								</span>
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}